export default __webpack_public_path__ + "static/media/pinkPlayer.2db39f24.svg";